export { StyledGlobalSearch, StyledGlobalSearchWithoutClickOutside, StyledGlobalSearchWithoutHotKey, StyledGlobalSearchWithoutHotKeyOrClickOutside } from './src/global-search';
export { renderPageSearch } from './src/page-result-view';
export { getDefaultGlobalSearchStyles } from './src/default-global-search-styles';
export { PagesSearchEngine } from './src/pages-search-engine';
